import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, createVNode as _createVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-8380a0ec"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "message-bubble",
  ref: "htmlRefHook"
}
const _hoisted_2 = ["src"]
const _hoisted_3 = { class: "message-area" }
const _hoisted_4 = { class: "message-area-title" }
const _hoisted_5 = { class: "name" }
const _hoisted_6 = { class: "time" }
const _hoisted_7 = { class: "content content-in" }
const _hoisted_8 = { key: 1 }
const _hoisted_9 = ["src"]
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon icon-voice" }, null, -1))
const _hoisted_11 = {
  key: 4,
  class: "message-video-cover"
}
const _hoisted_12 = ["src"]
const _hoisted_13 = ["src"]
const _hoisted_14 = {
  key: 6,
  class: "message-file"
}
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon icon-files" }, null, -1))
const _hoisted_16 = { class: "message-file-content" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MessageText = _resolveComponent("MessageText")!
  const _component_MessageEmojiReact = _resolveComponent("MessageEmojiReact")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["replies-item", !_ctx.isRoot ? 'replies-item-normal' : ''])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("img", {
        class: "avatar",
        src: _ctx.message?.avatar || 'https://image.iguopin.com/data/app/im-logo.png',
        onerror: "this.src='https://image.iguopin.com/data/app/im-logo.png'"
      }, null, 8, _hoisted_2),
      _createElementVNode("main", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("label", _hoisted_5, _toDisplayString(_ctx.isRoot ? _ctx.message.nameCard || _ctx.message.nick || _ctx.message.from : _ctx.message.messageSender), 1),
          _createElementVNode("label", _hoisted_6, _toDisplayString(_ctx.isRoot && _ctx.message?.time ? _ctx.caculateTimeago(_ctx.message.time * 1000) : ""), 1)
        ]),
        _createElementVNode("div", _hoisted_7, [
          (
              _ctx.message.messageType === _ctx.constant.typeText ||
              _ctx.message.type === _ctx.TIM.TYPES.MSG_TEXT ||
              !_ctx.isRoot
            )
            ? (_openBlock(), _createBlock(_component_MessageText, {
                key: 0,
                data: 
              _ctx.handleTextMessageShowContext(
                _ctx.isRoot ? _ctx.message : { payload: { text: _ctx.message?.messageAbstract } }
              )
            
              }, null, 8, ["data"]))
            : _createCommentVNode("", true),
          (
              _ctx.message.messageType === _ctx.constant.typeCustom || _ctx.message.type === _ctx.TIM.TYPES.MSG_CUSTOM
            )
            ? (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(_ctx.handleCustomMessageShowContext(_ctx.message)?.custom), 1))
            : _createCommentVNode("", true),
          (
              _ctx.message.messageType === _ctx.constant.typeImage || _ctx.message.type === _ctx.TIM.TYPES.MSG_IMAGE
            )
            ? (_openBlock(), _createElementBlock("img", {
                key: 2,
                class: "message-img",
                src: _ctx.message?.payload?.imageInfoArray[1].url
              }, null, 8, _hoisted_9))
            : _createCommentVNode("", true),
          (
              _ctx.message.messageType === _ctx.constant.typeAudio || _ctx.message.type === _ctx.TIM.TYPES.MSG_AUDIO
            )
            ? (_openBlock(), _createElementBlock("div", {
                key: 3,
                class: "message-audio",
                style: _normalizeStyle(`width: ${_ctx.message?.payload?.second * 10 + 40}px`)
              }, [
                _hoisted_10,
                _createElementVNode("label", null, _toDisplayString(_ctx.message?.payload?.second) + "s", 1)
              ], 4))
            : _createCommentVNode("", true),
          (
              _ctx.message.messageType === _ctx.constant.typeVideo || _ctx.message.type === _ctx.TIM.TYPES.MSG_VIDEO
            )
            ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                _createElementVNode("img", {
                  class: "message-videoimg",
                  src: _ctx.message?.payload?.snapshotUrl || _ctx.message?.payload?.thumbUrl
                }, null, 8, _hoisted_12)
              ]))
            : _createCommentVNode("", true),
          (_ctx.message.messageType === _ctx.constant.typeFace || _ctx.message.type === _ctx.TIM.TYPES.MSG_FACE)
            ? (_openBlock(), _createElementBlock("img", {
                key: 5,
                class: "message-img",
                src: _ctx.url
              }, null, 8, _hoisted_13))
            : _createCommentVNode("", true),
          (_ctx.message.messageType === _ctx.constant.typeFile || _ctx.message.type === _ctx.TIM.TYPES.MSG_FILE)
            ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                _hoisted_15,
                _createElementVNode("div", _hoisted_16, [
                  _createElementVNode("label", null, _toDisplayString(_ctx.message?.payload?.fileName), 1),
                  _createElementVNode("span", null, _toDisplayString(_ctx.handleFileMessageShowContext(_ctx.message)?.size || _ctx.message?.payload?.fileSize), 1)
                ])
              ]))
            : _createCommentVNode("", true),
          _createVNode(_component_MessageEmojiReact, {
            message: _ctx.message,
            type: "content"
          }, null, 8, ["message"])
        ])
      ])
    ], 512)
  ], 2))
}